import { PropsWithChildren, useLayoutEffect, useRef } from 'react'

import { useSize } from 'ahooks'

import { pick } from '../../../utils/object'
import { useRemoteTransferStore } from '../Store/hooks/useStore'

import { RemoteTransferRightPanelProps } from './interface'

export const RemoteTransferLeftPanel = ({ children }: PropsWithChildren) => {
  const { setPanelHeight } = useRemoteTransferStore(state =>
    pick(state, ['setPanelHeight'])
  )

  const containerRef = useRef<HTMLDivElement>(null)
  const size = useSize(containerRef)
  const height = size?.height

  useLayoutEffect(() => {
    if (height) {
      setPanelHeight(height)
    }
  }, [height, setPanelHeight])

  return <div ref={containerRef}>{children}</div>
}

export const RemoteTransferRightPanel = ({
  syncHeight,
  header,
  footer,
  children
}: PropsWithChildren<RemoteTransferRightPanelProps>) => {
  const { panelHeight } = useRemoteTransferStore(state =>
    pick(state, ['panelHeight'])
  )

  const headerRef = useRef<HTMLDivElement>(null)
  const bodyRef = useRef<HTMLDivElement>(null)
  const footerRef = useRef<HTMLDivElement>(null)

  const headerSize = useSize(headerRef)
  const footerSize = useSize(footerRef)

  const headerHeight = headerSize?.height ?? 0
  const footerHeight = footerSize?.height ?? 0

  useLayoutEffect(() => {
    if (panelHeight && syncHeight) {
      const bodyHeight = panelHeight - headerHeight - footerHeight
      if (bodyRef.current) {
        bodyRef.current.style.height = `${bodyHeight}px`
        bodyRef.current.style.overflowY = 'auto'
      }
    }
  }, [syncHeight, panelHeight, headerHeight, footerHeight])

  return (
    <>
      <div ref={headerRef}>{header}</div>
      <div ref={bodyRef}>{children}</div>
      <div ref={footerRef}>{footer}</div>
    </>
  )
}
